import { VcCommunicator } from "./vccommunicator";
import {VcGlobal} from "./vcglobal_conn";
console.log("VcCommunicatorOpenAI class")


VcCommunicator.prototype.sendaimessage=function(threadId, message, assistantId) {
    var me=this;

    var config={
        threadId:threadId,
        message:message
    };

    if (assistantId) {
        config.assistantId = assistantId;
    }

    return me.retrieveData(this.createUrl("sendaimessage",null, VcGlobal.AI_PROXY_SERVER_PATH), config);
}

VcCommunicator.prototype.getairunstatus=function(threadId, runId) {
    var me=this;

    var config={
        threadId:threadId,
        runId:runId
    };

    return me.retrieveData(this.createUrl("getairunstatus",null, VcGlobal.AI_PROXY_SERVER_PATH), config);
}

VcCommunicator.prototype.getaimessages=function(threadId, runId) {
    var me=this;

    var config={
        threadId:threadId,
        runId:runId
    };

    return me.retrieveData(this.createUrl("getaimessages",null, VcGlobal.AI_PROXY_SERVER_PATH), config);
}


VcCommunicator.prototype.streamaimessage = function(threadId, message, assistantId, onChunk, onComplete, onError) {
    var me = this;
    
    // Since EventSource only supports GET, we need to use fetch with ReadableStream
    var config = {
        sessionId: me.sessionId || '',
        threadId: threadId || '',
        message: message,
        assistantId: assistantId || ''
    };
    
    var url = me.createUrl("streamaithread", null, VcGlobal.AI_PROXY_SERVER_PATH);
    
    var fullResponse = {
        main_answer: '',
        code: '',
        language: '',
        description: '',
        notes: [],
        requirements: []
    };
    var currentJson = '';
    var reader = null; // Keep reference for cleanup
    
    // Function to attempt to fix incomplete JSON (same as before)
    function tryFixIncompleteJson(jsonStr) {
        // First try parsing as-is
        try {
            return JSON.parse(jsonStr);
        } catch (e) {
            // Continue to fix attempts
        }
        
        let fixed = jsonStr.trim();
        
        // Count open/close braces and brackets
        let openBraces = (fixed.match(/{/g) || []).length;
        let closeBraces = (fixed.match(/}/g) || []).length;
        let openBrackets = (fixed.match(/\[/g) || []).length;
        let closeBrackets = (fixed.match(/\]/g) || []).length;
        
        // Try to fix unclosed strings
        // Look for the last quote and check if it's properly closed
        let inString = false;
        let lastQuoteIndex = -1;
        let escapeNext = false;
        
        for (let i = 0; i < fixed.length; i++) {
            if (escapeNext) {
                escapeNext = false;
                continue;
            }
            if (fixed[i] === '\\') {
                escapeNext = true;
                continue;
            }
            if (fixed[i] === '"') {
                inString = !inString;
                lastQuoteIndex = i;
            }
        }
        
        // If we're still in a string, close it
        if (inString) {
            fixed += '"';
        }
        
        // Remove trailing comma if present
        fixed = fixed.replace(/,\s*$/, '');
        
        // Close any open arrays
        while (openBrackets > closeBrackets) {
            fixed += ']';
            closeBrackets++;
        }
        
        // Close any open objects
        while (openBraces > closeBraces) {
            fixed += '}';
            closeBraces++;
        }
        
        // Try parsing the fixed JSON
        try {
            return JSON.parse(fixed);
        } catch (e) {
            // If still failing, try more aggressive fixes
            
            // Check if we need to close an array or object after the last value
            if (fixed.match(/:\s*"[^"]*"\s*$/)) {
                // Ends with a string value, might need closing brace
                fixed += '}';
            } else if (fixed.match(/:\s*\d+\.?\d*\s*$/)) {
                // Ends with a number value
                fixed += '}';
            } else if (fixed.match(/:\s*(true|false|null)\s*$/)) {
                // Ends with boolean or null
                fixed += '}';
            } else if (fixed.match(/\[\s*$/)) {
                // Ends with array opening
                fixed += ']';
            } else if (fixed.match(/{\s*$/)) {
                // Ends with object opening
                fixed += '}';
            }
            
            try {
                return JSON.parse(fixed);
            } catch (finalError) {
                // Return null if we can't fix it
                return null;
            }
        }
    }
    
    // Use fetch with streaming response
    const fetchPromise = fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'text/event-stream'
        },
        body: new URLSearchParams(config).toString()
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        
        function processText(text) {
            // SSE format: each message starts with "data: " and ends with "\n\n"
            const lines = text.split('\n');
            let errorMessage = '';
            let currentEvent = '';
            
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i];
                
                if (line.startsWith('data: ')) {
                    const data = line.substring(6);
                    if (currentEvent === 'error') {
                        // Accumulate error message
                        errorMessage += data;
                    } else if (currentEvent === 'error') {
                        // Accumulate error message
                        errorMessage += data;
                    } else if (currentEvent === 'thread') {
                        // Handle thread event that provides threadId
                        try {
                            const threadData = JSON.parse(data);
                            if (threadData.threadId) {
                                fullResponse.thread_id = threadData.threadId;
                                // Notify the caller about the thread ID immediately
                                if (onChunk) {
                                    onChunk(fullResponse);
                                }
                            }
                        } catch (e) {
                            console.error('Failed to parse thread data:', e);
                        }
                    } else if (currentEvent === 'message' && data) {
                        //console.log('Received message data:', data);
                        currentJson += data;
                        
                        // Try to parse or fix the JSON
                        const parsed = tryFixIncompleteJson(currentJson);
                        if (parsed) {
                            Object.assign(fullResponse, parsed);
                             if (onChunk) {
                                onChunk(fullResponse);
                            }
                        }
                    }
                } else if (line.startsWith('event: ')) {
                    // If we had an error event with data, process it
                    if (currentEvent === 'error' && errorMessage) {
                        if (onError) {
                            try {
                                const errorObj = JSON.parse(errorMessage);
                                onError(new Error(errorObj.message || errorObj.error || errorMessage));
                            } catch (e) {
                                onError(new Error(errorMessage));
                            }
                        }
                        return false; // Stop reading
                    }
                    
                    const eventType = line.substring(7).trim();
                    currentEvent = eventType;
                    
                    if (eventType === 'complete') {
                        // Final attempt to parse/fix JSON if needed
                        if (currentJson) {
                            const finalParsed = tryFixIncompleteJson(currentJson);
                            if (finalParsed) {
                                fullResponse = finalParsed;
                            }
                        }
                        
                        if (onComplete) {
                            onComplete(fullResponse);
                        }
                        return false; // Stop reading
                    } else if (eventType === 'error') {
                        errorMessage = '';
                    }
                } else if (line === '' && i < lines.length - 1) {
                    // Empty line in the middle of the text indicates end of an SSE message
                    // Process any pending error
                    if (currentEvent === 'error' && errorMessage) {
                        if (onError) {
                            try {
                                const errorObj = JSON.parse(errorMessage);
                                onError(new Error(errorObj.message || errorObj.error || errorMessage));
                            } catch (e) {
                                onError(new Error(errorMessage));
                            }
                        }
                        return false; // Stop reading
                    }
                    // Reset for next message
                    currentEvent = '';
                    errorMessage = '';
                }
            }
            
            // Process error if this was the last chunk of an error event
            if (currentEvent === 'error' && errorMessage) {
                onError(new Error(errorMessage));
                return false; // Stop reading
            }
            
            return true; // Continue reading
        }
        
        function read() {
            reader.read().then(({done, value}) => {
                if (done) {
                    // Process any remaining buffer
                    if (buffer) {
                        processText(buffer);
                    }
                    
                    // If we didn't get a complete event, still try to return what we have
                    if (currentJson) {
                        const salvaged = tryFixIncompleteJson(currentJson);
                        if (salvaged && onComplete) {
                            onComplete(salvaged);
                            return;
                        }
                    }
                    
                    if (onError) {
                        onError(new Error('Stream ended unexpectedly'));
                    }
                    return;
                }
                
                // Decode the chunk and add to buffer
                buffer += decoder.decode(value, {stream: true});
                
                // Process complete messages (ending with \n\n)
                let lastIndex = 0;
                let index;
                while ((index = buffer.indexOf('\n\n', lastIndex)) !== -1) {
                    const message = buffer.substring(lastIndex, index);
                    const shouldContinue = processText(message);
                    if (!shouldContinue) {
                        reader.cancel();
                        return;
                    }
                    lastIndex = index + 2;
                }
                
                // Keep the incomplete part in the buffer
                buffer = buffer.substring(lastIndex);
                
                // Continue reading
                read();
            }).catch(error => {
                if (onError) {
                    onError(error);
                }
            });
        }
        
        // Start reading
        read();
    })
    .catch(error => {
        if (onError) {
            onError(error);
        }
    });
    
    // Return an object that can be used to cancel the stream
    return {
        close: function() {
            if (reader) {
                reader.cancel();
            }
        }
    };
};